export const INPROCESSING = "INPROCESSING"
export const PAUSED = "PAUSED"
export const WAITING = "WAITING"
export const MISSEDCALL = "MISSEDCALL"
export const MOVING = "MOVING"